import React from "react";
import { REVIEWS_LIST } from "../../common";
import { ReviewsCard } from "../ReviewCard";
import style from "./ReviewsList.module.css";

export const ReviewsList = () => (
  <div className={style.reviewsList}>
    {REVIEWS_LIST.map((review) => (
      <ReviewsCard key={review.id} review={review} />
    ))}
  </div>
);
